// Shared types and helpers for the bag reorder tracker (Bags page, the
// app-wide reorder banner, and the Settings card).

export type BagSize = 'Small' | 'Large'

export interface BagSizeStatus {
  size: BagSize
  tracking: boolean
  on_hand: number
  start_date: string | null
  received_since_start: number
  used_since_start: number
  avg_daily_use: number
  lead_time_days: number
  suggested_reorder_point: number
  reorder_point_override: number | null
  reorder_point: number
  needs_reorder: boolean
  days_left: number | null
  reorder_by: string | null
  out_by: string | null
}

export interface BagEntry {
  id: number
  size: BagSize
  kind: 'received' | 'count'
  quantity: number
  received_on: string
  note: string | null
  created_at: string
}

export interface BagStatus {
  today: string
  usage_window_days: number
  sizes: BagSizeStatus[]
  entries: BagEntry[]
}

// Fired after bag entries or settings change so the header banner refreshes.
export const BAG_STATUS_CHANGED = 'bag-status-changed'

export function notifyBagStatusChanged() {
  window.dispatchEvent(new Event(BAG_STATUS_CHANGED))
}

// Formats a YYYY-MM-DD day without shifting it across time zones.
export function formatDay(day: string | null): string {
  if (!day) return '—'
  const d = new Date(`${day}T00:00:00`)
  if (Number.isNaN(d.getTime())) return day
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function localToday(): string {
  const d = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export const bags = (n: number) => `${n.toLocaleString('en-US')} bag${n === 1 ? '' : 's'}`
